import { IGpsItem } from './gps-item';

export interface IGpsBatchResult {
    imei: string,
    success: boolean,
    results: IGpsItem[]
}